/**
 * Component: AnalisisExtracciones
 * Package: AnalisisExtracciones
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\analisisExtracciones\AnalisisExtracciones.js
 *
 * Requisito funcional: RQ08-001
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera una tabla que permite listar las extracciones almacenadas.
 */

import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import ListadoPage from '../../containers/page/ListadoPage'
import FiltrosAnalisisExtraccionesPage from '../../containers/analisisExtracciones/FiltrosAnalisisExtraccionesPage'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import {estadoVerraco,cantidadCeroVacio} from '../comun/table/Stilyzers'
import { date_parser, number_formatter, dateTimeZones } from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'

class AnalisisExtracciones extends Component {
  constructor () {
    super()
    this.state = {
      media: false,
      metodoEvaluacion: '',
      idMotilidad: '',
      nameMotilidad: ''
    }
  }

  componentDidMount () {
    document.title = this.props.t('MENU.EXTRACCIONES.ANALISIS') + ' - ' + this.props.t('HEADER.TITLE_GESIPOR')  
    this.props.actions.obtenerDatosPanelControl()
  }

  componentDidUpdate (prevProps) {
    if (this.props.panelControl !== prevProps.panelControl) {
      if (Object.keys(this.props.panelControl).length > 0){
        this.setState({metodoEvaluacion: this.props.panelControl.datosPanel.metodoEvaluacion})
        if (this.props.panelControl.datosPanel.metodoEvaluacion === 1) {
          this.setState({idMotilidad: 'motilidadTotal'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MOTILIDAD')})
        }
        if (this.props.panelControl.datosPanel.metodoEvaluacion === 2) {
          this.setState({idMotilidad: 'motilidadTotal'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MOTILIDAD')})
        }
        if (this.props.panelControl.datosPanel.metodoEvaluacion === 4) {
          this.setState({idMotilidad: 'motilidadMasal'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MOT_MASAL')})
        }
        if (this.props.panelControl.datosPanel.metodoEvaluacion === 3) {
          this.setState({idMotilidad: 'mt'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MT')})
        }
        if (this.props.panelControl.datosPanel.metodoEvaluacion === 5) {
          this.setState({idMotilidad: 'mt'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MT')})
        }
      }
    }
  }

  render () {
    const {
      list = [], totales, checkedFiltrosAnalisisExtracciones, t, numeroRegistrosPorPagina, paginaActual, filtros,
      actions: {onDeleteAnalisisExtraccion, cambiarVigiladoAnalisisExtracciones, cambiarEyaculadoEliminadoAnalisisExtracciones},
      auth: {separadorDec, separadorMil},
      ultimasExtraccionesVerraco
    } = this.props

    const tKey = 'ANALISIS_EXTRACCIONES.'
    const idElemento = 'idAnalisis'
    const table = {
      id: 'analisisExtraccionesTable',
      multiHeader: false,
      hasCheckbox: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1),
      idElemento,
      hasOptions: true,
      mostrarModificar: true,
      onEdit: (row) => this.props.history.push('EditarAnalisisExtraccion/' + row.idAnalisis),
      mostrarDuplicar: false,
      mostrarEliminar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1),
      onDelete: (row) => onDeleteAnalisisExtraccion(row.idAnalisis),
      vigilado: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1),
      cambiarVigilado: (row) => cambiarVigiladoAnalisisExtracciones(row.idVerraco),
      mostrarCambiarEyaculadoEliminado: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1),
      cambiarEyaculadoEliminado: (row) => row.diluido ? this.props.actions.yesNoModal('extraccionDiluida') : cambiarEyaculadoEliminadoAnalisisExtracciones(row.idAnalisis),
      mostrarCambioEstado: false,
      columns: this.state.metodoEvaluacion === 3 || this.state.metodoEvaluacion === 5 ? ([
        {id: 'codigo', name: t(tKey + 'COLUMNS.COD_EXTRACCION'), type: 'numero', numDecimales: 0},
        {id: 'numseguimientos', name: t(tKey + 'COLUMNS.SEGUIMIENTO'), type: 'numero', numDecimales: 0},
        // {id: 'codVerraco', name: t(tKey + 'COLUMNS.VERRACO'), mostrarUltimasExtraccionesVerracoPopover: true, idMotilidad: this.state.idMotilidad, nameMotilidad: this.state.nameMotilidad},
        {id: 'codVerraco', name: t(tKey + 'COLUMNS.VERRACO'), mostrarUltimasExtraccionesVerracoNuevo: true, ultimasExtraccionesVerraco:ultimasExtraccionesVerraco},
        {id: 'orden', name: t(tKey + 'COLUMNS.ORDEN'), type: 'numero', numDecimales: 0},
        {id: 'estadoVerraco', name: t(tKey + 'COLUMNS.ESTADO'), stilyzer: estadoVerraco},
        {id: 'fechaExtraccion', name: t(tKey + 'COLUMNS.FECHA'), type: 'fecha'},
        {id: 'nombreRaza', name: t(tKey + 'COLUMNS.RAZA')},
        {id: 'nombreLinea', name: t(tKey + 'COLUMNS.LIN_GENETICA')},
        {id: 'ebv', name: t(tKey + 'COLUMNS.INDEX')},
        {id: 'nivelGenetico', name: t(tKey + 'COLUMNS.NIVEL_GENETICO')},
        {id: 'nombreTipoDosis', name: t(tKey + 'COLUMNS.TIPO_DOSIS')},
        {id: 'volumen', name: t(tKey + 'COLUMNS.VOL'), type: 'numero', numDecimales: 0},
        {id: 'concentracionTotal', name: t(tKey + 'COLUMNS.CONCENTRACION_TOTAL'), type: 'numero'},
        {id: 'concentracionUtil', name: t(tKey + 'COLUMNS.CONCENTRACION_UTIL'), type: 'numero'},
        {id: this.state.idMotilidad, name: this.state.nameMotilidad, type: 'numero'},
        {id: 'mp', name: this.props.t('INFORMES.EXTRACCIONES.TABLA.MP'), type: 'numero'},
        {id: 'porFaTotal', name: t(tKey + 'COLUMNS.FORMAS_ANORMALES'), type: 'numero'},
        {id: 'temperaturaEyaculado', name: t(tKey + 'COLUMNS.TEMPERATURA_EYACULADO'), type: 'numero'},
        {id: 'nombre', name: t(tKey + 'COLUMNS.TIPO_DILUYENTE')},
        {id: 'volumenDiluyente', name: t(tKey + 'COLUMNS.VOL_DILUYENTE'), type: 'numero', numDecimales: 0},
        {id: 'dosisReales', name: t(tKey + 'COLUMNS.N_DOSIS_REALES'), type: 'numero', numDecimales: 0},
        {id: 'vigilado', name: t(tKey + 'COLUMNS.VIGILADO')},
        (this.props.auth.customizations && this.props.auth.customizations.includes("DataSwine")) && {id: 'sincronizado', name: t(tKey + 'COLUMNS.SINCRONIZADO')}
      ]) : ([
        {id: 'codigo', name: t(tKey + 'COLUMNS.COD_EXTRACCION'), type: 'numero', numDecimales: 0},
        {id: 'numseguimientos', name: t(tKey + 'COLUMNS.SEGUIMIENTO'), type: 'numero', numDecimales: 0},
        // {id: 'codVerraco', name: t(tKey + 'COLUMNS.VERRACO'), mostrarUltimasExtraccionesVerracoPopover: true, idMotilidad: this.state.idMotilidad, nameMotilidad: this.state.nameMotilidad},
        {id: 'codVerraco', name: t(tKey + 'COLUMNS.VERRACO'), mostrarUltimasExtraccionesVerracoNuevo: true, ultimasExtraccionesVerraco:ultimasExtraccionesVerraco},
        {id: 'orden', name: t(tKey + 'COLUMNS.ORDEN'), type: 'numero', numDecimales: 0},
        {id: 'estadoVerraco', name: t(tKey + 'COLUMNS.ESTADO'), stilyzer: estadoVerraco},
        {id: 'fechaExtraccion', name: t(tKey + 'COLUMNS.FECHA'), type: 'fecha'},
        {id: 'nombreRaza', name: t(tKey + 'COLUMNS.RAZA')},
        {id: 'nombreLinea', name: t(tKey + 'COLUMNS.LIN_GENETICA')},
        {id: 'ebv', name: t(tKey + 'COLUMNS.INDEX')},
        {id: 'nivelGenetico', name: t(tKey + 'COLUMNS.NIVEL_GENETICO')},
        {id: 'nombreTipoDosis', name: t(tKey + 'COLUMNS.TIPO_DOSIS')},
        {id: 'volumen', name: t(tKey + 'COLUMNS.VOL'), type: 'numero', numDecimales: 0},
        {id: 'concentracionTotal', name: t(tKey + 'COLUMNS.CONCENTRACION_TOTAL'), type: 'numero'},
        {id: 'concentracionUtil', name: t(tKey + 'COLUMNS.CONCENTRACION_UTIL'), type: 'numero'},
        {id: this.state.idMotilidad, name: this.state.nameMotilidad, type: 'numero'},
        {id: 'porFaTotal', name: t(tKey + 'COLUMNS.FORMAS_ANORMALES'), type: 'numero'},
        {id: 'temperaturaEyaculado', name: t(tKey + 'COLUMNS.TEMPERATURA_EYACULADO'), type: 'numero'},
        {id: 'nombre', name: t(tKey + 'COLUMNS.TIPO_DILUYENTE')},
        {id: 'volumenDiluyente', name: t(tKey + 'COLUMNS.VOL_DILUYENTE'), type: 'numero', numDecimales: 0},
        {id: 'dosisReales', name: t(tKey + 'COLUMNS.N_DOSIS_REALES'), type: 'numero', numDecimales: 0},
        {id: 'vigilado', name: t(tKey + 'COLUMNS.VIGILADO')},
        (this.props.auth.customizations && this.props.auth.customizations.includes("DataSwine")) && {id: 'sincronizado', name: t(tKey + 'COLUMNS.SINCRONIZADO')}
      ]),
      rows: list,
      filtros: <FiltrosAnalisisExtraccionesPage idElemento={idElemento} />,
      leyenda: [
        {name: t(tKey + "LEYENDA.EXTRACCIONES_NO_ANALIZADAS"), color: '#e4d841'},
        {name: t(tKey + "LEYENDA.EYACULADO_ELIMINADO"), color: '#c4415d'},
        {name: t(tKey + "LEYENDA.PERTENECE_POOL"), color: '#2538aa'},
        ...(this.props.auth.customizations && Object.values(this.props.auth.customizations).includes('Ciaro')
          ? [{name: t(tKey + "LEYENDA.POOL_PARCIAL"), color: '#41e441', type: 'pool_parcial'}]
          : []),
        {name: t(tKey + "LEYENDA.ACTIVO"), color: '#c0d2a1'},
        {name: t(tKey + "LEYENDA.PRESENTE"), color: '#aacfdc'},
        {name: t("FICHA_VERRACO.LEYENDA.ENFERMO"), color: '#de9ed7'},
        {name: t(tKey + "LEYENDA.CUARENTENA"), color: '#edd3a0'},
      ],
      initialValues: {},
      colorearRow: (row) => {
        let classRow = ''
        if (row.eyaculadoEliminado){
          classRow = 'analisis-eyaculado-eliminado'
        }
        if (row.idPool){
          classRow = 'analisis-pertenece-pool'                
          if (this.props.auth.customizations && this.props.auth.customizations.includes('Ciaro')){
            if (row.poolParcial === 2){
              classRow = 'pool-parcial'}
        }
        }
        if (row.idTipoAnalisis === null){
          classRow = 'extraccion-sin-analisis'
        }

        return classRow
      }
    }
    table.rows.forEach(
      (row, idRow) => {
        // console.log("ROW:")
        // console.log(row)
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          table.initialValues['check' + row[idElemento]] = checkedFiltrosAnalisisExtracciones
        }
      }
    )
    return (
      <div>
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <ListadoPage t_key={tKey} table={table}>
        </ListadoPage>
        <Row className="tablaTotales" style={{ margin: '20px 0px 0px 0px'}}>
          <Col sm={12} className="total-verracos">
            <span>{t(tKey+ 'TOTALES.RESUMEN_DIARIO')}
              {
                Object.keys(filtros).length > 0 ? ([
                  (filtros.raza || filtros.lineaGenetica || filtros.propiedad ? <span key="parentesis1" >{" ("}</span> : null),
                  (filtros.raza && <span key="filtros.raza" >{ '-' + t(tKey + 'FILTROS.RAZA') + ': '}<span style={{fontWeight: 'normal'}}>{filtros.raza.label}</span></span>),
                  (filtros.lineaGenetica && <span key="filtros.lineaGenetica" >{' -' + t(tKey + 'FILTROS.LINEA_GENETICA') + ': '}<span style={{fontWeight: 'normal'}}>{filtros.lineaGenetica.label}</span></span>),
                  (filtros.propiedad && <span key="filtros.propiedad" >{' -' + t(tKey + 'FILTROS.PROPIEDAD') + ': '}<span style={{fontWeight: 'normal'}}>{filtros.propiedad.label}</span></span>),
                  (filtros.raza || filtros.lineaGenetica || filtros.propiedad ? <span key="parentesis2" >{")"}</span> : null)
                ]) : null
              }
            </span>
          </Col>
          {(totales && Object.keys(totales).length > 0) ? Object.keys(totales).map((tipoDosis) => {
            let totalPorDosis = totales[tipoDosis]
            return [
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'tipoDosis'}>
                <span>{totalPorDosis.nombreTipoDosis}</span>
              </Col>,
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'totalExtracciones'}>
                <span>{t(tKey+ 'TOTALES.TOTAL_EXTRACCIONES')}: {totalPorDosis.totalExtracciones !== undefined ? number_formatter(totalPorDosis.totalExtracciones, 0, separadorDec, separadorMil) : 0}</span>
              </Col>,
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'totalDosisProducidas'}>
                <span>{t(tKey+ 'TOTALES.TOTAL_DOSIS_PRODUCIDAS')}: {totalPorDosis.totalDosisProducidas !== undefined ? number_formatter(totalPorDosis.totalDosisProducidas, 0, separadorDec, separadorMil) : 0}</span>
              </Col>,
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'totalDosisPedidas'}>
                <span>{t(tKey+ 'TOTALES.TOTAL_DOSIS_PEDIDAS')}: {totalPorDosis.totalDosisPedidas !== undefined ? number_formatter(totalPorDosis.totalDosisPedidas, 0, separadorDec, separadorMil) : 0}</span>
              </Col>
            ]
          }) : (
            <Col sm={12} className="estados-total-verraco" >
              <span>{t(`COMUN.SIN_RESULTADOS`)}</span>
            </Col>
          )}
        </Row>
      </div>
    )
  }
}

export default AnalisisExtracciones
